import axios from 'axios';
import resolvePath from 'utils/resolvePath';
// Action
const CLEAR = 'specialFeatures/clear';
const GET_SPECIAL_FEATURES_REQUEST = 'specialFeatures/getSpecialFeaturesRequest';
const GET_SPECIAL_FEATURES_SUCCESS = 'specialFeatures/getSpecialFeaturesSuccess';
const GET_SPECIAL_FEATURES_FAILURE = 'specialFeatures/getSpecialFeaturesFailure';
const GET_SPECIAL_FEATURES_USERS_REQUEST = 'specialFeatures/getSpecialFeaturesUsersRequest';
const GET_SPECIAL_FEATURES_USERS_SUCCESS = 'specialFeatures/getSpecialFeaturesUsersSuccess';
const GET_SPECIAL_FEATURES_USERS_FAILURE = 'specialFeatures/getSpecialFeaturesUsersFailure';
// Action Creator
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getSpecialFeaturesRequest = () => {
    return {
        type: GET_SPECIAL_FEATURES_REQUEST,
    };
};
export const getSpecialFeaturesSuccess = (specialFeatures) => {
    return {
        payload: {
            specialFeatures,
        },
        type: GET_SPECIAL_FEATURES_SUCCESS,
    };
};
export const getSpecialFeaturesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_SPECIAL_FEATURES_FAILURE,
    };
};
export const getSpecialFeatures = (authToken) => {
    return (dispatch) => {
        dispatch(getSpecialFeaturesRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('special_features'), config)
            .then((response) => dispatch(getSpecialFeaturesSuccess(response.data)))
            .catch((error) => {
            dispatch(getSpecialFeaturesFailure(error));
            throw error;
        });
    };
};
export const getSpecialFeaturesUsersRequest = () => {
    return {
        type: GET_SPECIAL_FEATURES_USERS_REQUEST,
    };
};
export const getSpecialFeaturesUsersSuccess = (specialFeaturesUsers) => {
    return {
        payload: {
            specialFeaturesUsers,
        },
        type: GET_SPECIAL_FEATURES_USERS_SUCCESS,
    };
};
export const getSpecialFeaturesUsersFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_SPECIAL_FEATURES_USERS_FAILURE,
    };
};
export const getSpecialFeaturesUsers = (authToken, id, page) => {
    return (dispatch) => {
        dispatch(getSpecialFeaturesUsersRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: {
                page: page + 1,
                per_page: 10,
            },
        };
        return axios
            .get(`${resolvePath.api(`special_features/${id}`)}`, config)
            .then((response) => dispatch(getSpecialFeaturesUsersSuccess(response.data)))
            .catch((error) => {
            dispatch(getSpecialFeaturesUsersFailure(error));
            throw error;
        });
    };
};
const initialSpecialFeatureUsersState = {
    tag: null,
    users: [],
};
const initialState = {
    error: null,
    specialFeatures: [],
    specialFeaturesUsers: initialSpecialFeatureUsersState,
    page: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { specialFeaturesUsers: initialSpecialFeatureUsersState, page: 0 });
        }
        case GET_SPECIAL_FEATURES_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_SPECIAL_FEATURES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { specialFeatures: action.payload.specialFeatures });
        }
        case GET_SPECIAL_FEATURES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        case GET_SPECIAL_FEATURES_USERS_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_SPECIAL_FEATURES_USERS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { specialFeaturesUsers: {
                    tag: action.payload.specialFeaturesUsers.tag,
                    users: [
                        ...state.specialFeaturesUsers.users,
                        ...action.payload.specialFeaturesUsers.users,
                    ],
                }, page: state.page + 1 });
        }
        case GET_SPECIAL_FEATURES_USERS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        default: {
            return state;
        }
    }
};
